import { Type } from 'class-transformer';
import { BookmarkGroupModel } from './bookmark.group.model';
import { StoryType } from 'src/app/story/models/story-type.enum';

export class BookmarkModel {

  // Content
  id: string;
  type: StoryType = StoryType.Bookmark;
  sex: string;
  module_name?: string;

  // Metadata
  title: string;
  description: string;
  tags: string[];
  animated?: boolean;
  featured?: boolean;
  tour?: boolean;

  // Author
  author: string;
  author_first_name?: string;
  author_last_name?: string;

  // Audit
  create_date_time: Date;
  update_date_time?: Date;
  last_editor?: string;
  last_editor_first_name?: string;
  last_editor_last_name?: string;

  // Permissions
  @Type(() => BookmarkGroupModel)
  group_access?: BookmarkGroupModel[];
  is_owner?: false;

  // Cost  
  cost?: number;
  premium?: boolean;
  
  // Embeds
  embed_url: string;
  embed_url_path: string;
  embedded: any;

  // Share
  share: any;
  share_url: string;

  // favorites
  favorite = false;

  // Images
  icon: null;
  thumbnail_url: string;
  hires_img_url?: string;
  rotatable_url?: string;

  // Stream
  stream: any;
  stream_url: string;

  // legacy/orphaned content
  unavailable = false;

  // Collections
  collection_content?: boolean;
  collection_content_id?: number;
  collection_content_createdate?: string;

}
